
import { defineComponent } from 'vue';
import NoteIcon from "@/components/icons/IconNote.vue";
import CubeList from "@/components/CubeList.vue";

export default defineComponent({
  name: 'ProgramSection',
  components: {
    NoteIcon,
    CubeList
  }
});
